import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FirRemoto, Soggetto } from '../interfaces';
import { UtilityService } from '../../../services/utility.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { confirm } from 'devextreme/ui/dialog';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../services/fir-digitali-transaction.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
export type FileList = {
  allegato_id: number
  content_type: string
  nome_file: string
  contenuto: any
  identificativo_soggetto: string
  descrizione: any
}
export type FileRes = {

  size: number,
  mime: string
  nome_file: string
  content: any
}

@Component({
  selector: 'app-lista-allegati-annotazioni',
  templateUrl: './lista-allegati-annotazioni.component.html',
  styleUrls: ['./lista-allegati-annotazioni.component.css']
})
export class ListaAllegatiAnnotazioniComponent implements OnInit, OnDestroy {
  @Input() soggetto: Soggetto
  @Input() firRemoto: FirRemoto
  @Input() guid: string
  currentTask: DocumentTask
  protected dataList: Array<Record<string, any>> = []
  private readonly $destroy: Subject<void> = new Subject()
  constructor(
    private readonly ComponentService: ComponentService,
    private readonly Apiservice: Apiservice,
    private readonly loader: NgxSpinnerService,
    private readonly UtilityService: UtilityService,
    private readonly FirTransaction: FirDigitaliTransactionService,
  ) { }
  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }

  ngOnInit() {
    if (this.firRemoto.dati_allegati && this.firRemoto.dati_allegati.length > 0) this.dataList = this.firRemoto.dati_allegati.filter((val) => val.identificativo_soggetto === this.soggetto.codiceFiscale);
    this.FirTransaction.state$.pipe(takeUntil(this.$destroy)).subscribe({
      next: async (next: TransactionStateMap) => {
        if (next[this.firRemoto.dati_partenza.numero_fir] && next[this.firRemoto.dati_partenza.numero_fir].lastTask) {
          if (next[this.firRemoto.dati_partenza.numero_fir].listTask.every((task) => task.status === 'completed')) {
            if (next[this.firRemoto.dati_partenza.numero_fir].lastTask === "EliminaAllegato" || next[this.firRemoto.dati_partenza.numero_fir].lastTask === "Allegato") {
              const numero_fir = this.firRemoto.dati_partenza.numero_fir
              const firRemoto: FirRemoto = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}?idSoggetto=${this.soggetto.id}`) as FirRemoto
              this.firRemoto = firRemoto;
              this.dataList = firRemoto.dati_allegati;
            }
          }
        }
      },
    })
    this.FirTransaction.currentTask$.subscribe((next) => this.currentTask = next)
  }
  async view(item: FileList) {
    console.log(item)
    if (!item) return
    if (!this.firRemoto) return
    this.loader.show()
    try {
      const numero_fir = this.firRemoto.dati_partenza.numero_fir
      const fileData = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}/Allegato?idSoggetto=${this.soggetto.id}&identificativo_soggetto=${this.soggetto.codiceFiscale}&nome_file=${item.nome_file}`) as FileRes
      const guid = Math.random().toString().replace('0', '')
      const base64DataUrl = `data:${fileData.mime};base64,${fileData.content}`;
      const file = this.UtilityService.base64ToFileObj(base64DataUrl, fileData.nome_file);
      this.ComponentService.setNewPopUp(guid, 'NicaPopupPdfComponent', null, '900', null, { file }, false, true, `File: ${file.name}`)
    } catch { } finally {
      this.loader.hide()
    }
  }
  async download(item: FileList) {
    console.log(item)
    if (!item) return
    if (!this.firRemoto) return
    this.loader.show()
    try {
      const numero_fir = this.firRemoto.dati_partenza.numero_fir
      const fileData = await this.Apiservice.GetApi(`rentri/fir-digitali/${numero_fir}/Allegato?idSoggetto=${this.soggetto.id}&identificativo_soggetto=${this.soggetto.codiceFiscale}&nome_file=${item.nome_file}`) as FileRes
      const base64DataUrl = `data:${fileData.mime};base64,${fileData.content}`;
      const file = this.UtilityService.base64ToFileObj(base64DataUrl, fileData.nome_file);
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileData.nome_file.split('.')[0];
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch { } finally {
      this.loader.hide()
    }
  }
  async remove(item: FileList) {
    return confirm(`Sei sicuro di voler richiedere la cancellazione del file selezionato?`, 'Attenzione').then(async (res) => {
      if (!res) return
      if (!item) return
      if (!this.firRemoto) return
      this.loader.show()
      try {
        const numero_fir = this.firRemoto.dati_partenza.numero_fir
        return await this.FirTransaction.enqueueAction({
          endpoint: `rentri/fir-digitali/${numero_fir}/Allegato?idSoggetto=${this.soggetto.id}&allegato_id=${item.allegato_id}`,
          idSoggetto: this.soggetto.id,
          numeroFormulario: numero_fir,
          processId: 'EliminaAllegato',
          title: `${numero_fir}: Eliminazione Allegato`,
          credentials_id: item.allegato_id as any,
          getTransaction_id: async () => await this.Apiservice.DeleteApi(`rentri/fir-digitali/${numero_fir}/Allegato?idSoggetto=${this.soggetto.id}&allegato_id=${item.allegato_id}`) as Promise<{ transazione_id: string }>
        })
      } catch { } finally {
        this.loader.hide()
      }
    })
  }

}
